<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import store from "@/store";

export default {
  name: 'BlankLayout',
  mounted() {
    store.dispatch('loadUser')
  }
}
</script>

<style scoped>
</style>
